define('views/modules/goal/edit/types/custom-goal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models & collections
    'collections/calendar/personal-data/personal-data-types',
    'models/calendar/personal-data/personal-data-type',
    'collections/calendar/items',
    'collections/calendar/days',
    // views
    'views/modules/goal/edit/types/main-goal',
    'views/parts/form/select',
    'views/parts/form/textbox',
    // services
    'services/i18n',
    // templates
    'text!templates/modules/goal/edit/types/custom-goal.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models & collections
    CPersonalDataTypes,
    MPersonalDataType,
    CCalendarItems,
    CCalendarDays,
    // views
    VMainGoal,
    VSelect,
    VTextBox,
    // services
    i18n,
    // templates
    TCustomGoal
) {

    var VCustomGoal = VMainGoal.extend({
        template: TCustomGoal,

        regions: _.extend(VMainGoal.prototype.regions, {
            personalData: '.datatype-input',
        }),

        initialize: function(opt) {
            this.options = _.extend({}, {
                endValueAttr: 'goalTarget',
                startValueAttr: 'start',
                startValueLabel: 'goal:Custom-Goal-StartValue-Label',
                startValueHelp: 'messages:helpbox-goal-custom-goal',
            }, opt);

            this.personalDataTypes = new CPersonalDataTypes();


            this.lastCustomDataEntry = null;
            VMainGoal.prototype.initialize.call(this, this.options);

            var model = this.model;
            var collection = this.collection = new CPersonalDataTypes(),
                view = _.extend(this.view, {
                    personalData: new VSelect({
                        label: 'goal:Custom data',
                        labelposition: "top",
                        option: { label: 'name', value: MPersonalDataType.prototype.idAttribute },
                        attribute: 'customData_id',
                        model: model,
                        collection: collection,
                        onChange: this.onTypeChange,
                        context: this,
                    }),
                    personalDataTextbox: new VTextBox({
                        label: 'goal:Custom data',
                        labelposition: "top",
                    }),
                });
        },

        render: function() {
            VMainGoal.prototype.render.apply(this, arguments);

            if (this.model.isNew())
                this.assign(this.view.personalData, this.zone.$personalData);
            else
                this.assign(this.view.personalDataTextbox, this.zone.$personalData);

            var self = this;
            this.collection.fetch().done(function() {
                if (self.collection.length < 1) {
                    self.$el.find('.custom-data-form').addClass('hidden');
                    self.$el.find('.alert').removeClass('hidden');
                }
            });

            if (this.model.isNew())
                this.setStartValue(this.model.get('customData_id'));
            else {
                this.SelectedCustomDataType = this.collection.get(this.view.personalData.getValue());
                this.setCustomDataTypeTextboxValue();
                this.hideStartValue(this.model.get('sumGoal'));
                this.disableInput();
            }

            return this;
        },

        setCustomDataTypeTextboxValue: function() {
            var self = this;
            this.when(this.personalDataTypes.fetch())
                .then(function() {
                    self.view.personalDataTextbox.setValue(self.personalDataTypes.get(self.model.get('customData_id')).get('name'));

                    var customDataDefSumEntryVal = self.personalDataTypes.get(self.model.get('customData_id')).get('sumEntry');

                    if (self.model.get('sumGoal') !== customDataDefSumEntryVal) {
                        self.model.save({ 'sumGoal': customDataDefSumEntryVal }, { patch: true });
                    }
                });
        },

        setUnitAddons: function() {
            var view = this.view,
                model = this.model,
                unit = model.get('customData_unit');

            if (!unit) {
                var SelectedCustomDataType = this.collection.get(view.personalData.getValue());
                this.SelectedCustomDataType = SelectedCustomDataType;
                unit = SelectedCustomDataType ? i18n.t(SelectedCustomDataType.getUserUnit()) : '-';

                if (_.isEmpty(unit)) unit = 'U';
            }
            view.startValue.setAddonAfter(unit);
            view.endValue.setAddonAfter(unit);

            return this;
        },

        setStartValue: function(custumData_Id) {
            //We set the start value with the last calendar entry only for new goal
            if (!this.model.isNew() || _.isEmpty(custumData_Id))
                return;

            this.lastCustomDataEntry = null;
            var startValue = null;
            //Little round trip to server side to get the last calendar entry for the selected custom data type
            var CCalDays = new CCalendarDays(null, { type: 'custom_data', customDataId: custumData_Id, user: this.profile.get('_id') });
            CCalDays.fetch({ async: false });

            if (CCalDays.models.length > 0 && CCalDays.models["0"].attributes.items.length > 0) {
                this.lastCustomDataEntry = CCalDays.models["0"].attributes.items[0];
                startValue = CCalDays.models["0"].attributes.items[0].value;
                this.view.startValue.setValue(startValue);
            } else {
                this.view.startValue.setValue("");
            }
        },

        disableInput: function() {
            var view = this.view,
                model = this.model,
                isNewModel = model.isNew();
            view.type.setDisable(!isNewModel);
            view.startValue.setDisable(!isNewModel);
            view.personalDataTextbox.setDisable(!isNewModel);
        },
        ////////////
        // events //
        ////////////
        onTypeChange: function(model, value) {
            this.setUnitAddons();
            //If existing Goal of type Sum, no need for the start value
            if (!this.model.isNew()) {
                if (this.model.get('sumGoal'))
                    this.hideStartValue(true);
            } else {
                this.setStartValue(this.view.personalData.getValue());
                if (this.view.personalData.collection.length > 0 && !_.isEmpty(this.view.personalData.getValue()))
                    this.hideStartValue(this.collection.get(this.view.personalData.getValue()).get("sumEntry")); //WTF Backbone !!!
            }
        },
    });

    return VCustomGoal;
});

